import React from "react";
import ShopifyModal from "../../../../components/ShopifyModal";

const NewPersonVideo = ({getStartShow,currentStart,setGetStartShow,videoLink,videoTitle}) => {
  return (
    <div>
      <ShopifyModal
        id="new-person-video-modal"
        size="large"
        padding="none"
        open={getStartShow}
        onClose={() => setGetStartShow(false)}
        heading={videoTitle}
      >
        <div className="plan_grade_content">
          <div className="novice_video_title">
            
          </div>
          <div className="novice_video_modal_content">
            <iframe
              style={{ borderRadius: "20px" }}
              title="dropshipman"
              src={videoLink}
              width="880"
              height="500"
              frameBorder="0"
              referrerpolicy="strict-origin-when-cross-origin"
              allowFullScreen="allowfullscreen"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </div>
        </div>
      </ShopifyModal>
    </div>
  );
};

export default NewPersonVideo;
